import { onlyAccept, required } from '../helpers'
import { ValidationFunctions } from '../types'

export const checkbox: ValidationFunctions = {
  _self: {
    required,
    onlyAccept,
  },
}
